import queryString from 'query-string';
import ErrorCodes from 'mangools-commons/dist/constants/ErrorCodes';

import { APP_CONFIG } from 'mangools-commons/dist/configs/app'

import { parseDetail } from 'sources/parsers/TrackingStatsDataParser';

import DateFormatService from 'services/DateFormatService';

const ENDPOINT = '/trackings';

/**
 * Data source class handling communication with API for tracking stats data.
 */
class TrackingStatsSource {
    static getDetail({ accessToken, report, shareToken }, { id, from, to, kwIds }) {
        const fromWithTZ = DateFormatService.formatISOWithCurrentTZ(from);
        const toWithTZ = DateFormatService.formatISOWithCurrentTZ(to);
        let query = {};
        let headers = {};

        if (report === true) {
            query = queryString.stringify({ from: fromWithTZ, to: toWithTZ, share_token: shareToken });
            headers = {
                'Content-Type': 'application/json',
            };
        } else {
            query = queryString.stringify({ from: fromWithTZ, to: toWithTZ });
            headers = {
                'X-Access-Token': accessToken,
                'Content-Type': 'application/json',
            };
        }

        const requestURL = `${APP_CONFIG.API_HOST}${APP_CONFIG.API_PATH}${ENDPOINT}/${id}/stats?${query}`;
        const requestBody = {
            kwIds,
        };

        return fetch(requestURL, {
            method: 'POST',
            mode: 'cors',
            body: JSON.stringify(requestBody),
            headers,
        })
            .then(response => {
                if (response.ok) {
                    return response
                        .json()
                        .then(data => ({
                            error: false,
                            payload: parseDetail(data),
                        }))
                        .catch(ex => ({
                            error: true,
                            payload: {
                                requestURL,
                                status: ErrorCodes.PARSE_ERROR,
                                text: ex.toString(),
                            },
                        }));
                } else {
                    return response.json().then(e => ({
                        error: true,
                        payload: {
                            requestURL,
                            status: response.status,
                            text: e.error ? e.error.message : null,
                            type: e.error ? e.error.type : null,
                        },
                    }));
                }
            })
            .catch(ex => ({
                error: true,
                payload: {
                    requestURL,
                    status: ErrorCodes.FETCH_ERROR,
                    text: ex.toString(),
                },
            }));
    }
}

export default TrackingStatsSource;
